import { Injectable } from '@angular/core';

import { map, Observable } from 'rxjs';

import { HttpServiceHelper } from '@reg/shared/service';
import { IdentityRankingPointsEvent } from '@reg/shared/model';
import { IJsonApiResponse } from '@reg/shared/json-api/json-api.interface';

/**
 * Service to get Sports
 */
@Injectable()
export class IdentityRankingPointsEventService {
    private readonly identityApiBaseUrl: string;

    constructor(private http: HttpServiceHelper) {
        this.identityApiBaseUrl = http.configService.getBaseConfig('identityApiBaseUrl');
    }

    /**
     * Add or update a ranking points record
     */
    public save(
        rankingPointsEvent: IdentityRankingPointsEvent,
        queryParams: string[] = null,
    ): Observable<IdentityRankingPointsEvent> {
        let response: Observable<IJsonApiResponse>;
        const apiUrl: string = this.getApiUrl(
            rankingPointsEvent.rankingPointsId,
            rankingPointsEvent.id,
            null,
            queryParams,
        );

        if (rankingPointsEvent.id) {
            // Update existing ranking  points
            response = this.http.patch(apiUrl, rankingPointsEvent.serialize());
        } else {
            // Add a new ranking  points
            response = this.http.post(apiUrl, rankingPointsEvent.serialize());
        }

        return response
            .pipe(map((response: IJsonApiResponse) => (new IdentityRankingPointsEvent()).deserialize(response)));
    }

    /**
     * Delete the specified ranking points.
     */
    public delete(rankingPointsId: string, rankingPointsEventId: string): Observable<boolean> {
        const apiRequestUrl: string = this.getApiUrl(rankingPointsId, rankingPointsEventId);
        return this.http.delete(apiRequestUrl).pipe(map(() => true));
    }

    /**
     * Build the api's url based on the given parameters
     */
    private getApiUrl(
        rankingPointsId: string,
        rankingPointsEventId: string,
        includes: string[] = null,
        queryParams: string[] = null,
    ): string {
        let url: string = `${this.identityApiBaseUrl}/ranking-points/${rankingPointsId}/events/`;

        if (rankingPointsEventId) {
            url += rankingPointsEventId;
        }

        url += this.http.getQueryParameters(includes, queryParams);

        return url;
    }
}
